import { h, Component } from 'preact';
import PrimaryLocation from '../primary-location';
import SearchForLocation, { SearchResults } from '../search-for-location';
import FavoriteLocations from '../favorite-locations';
import RecentLocations from '../recent-locations';
import LoadingText from '../loading-text';
import { Text } from 'preact-i18n';
import { ClickOutsideDetector, Icon } from '@cube/blocks';
import style from './style';
import cx from 'classnames';

export default class LocationTextInput extends Component {
	handleOpenInput = () => {
		this.setState({ open: true });
	};

	handleCloseInput = () => {
		this.setState({ open: false });
	};

	handleSetCurrent = (...args) => {
		this.props.onSetCurrent && this.props.onSetCurrent(...args);
		this.handleCloseInput();
	};

	handleAddFavorite = (...args) => {
		this.props.onAddFavorite && this.props.onAddFavorite(...args);
		this.handleCloseInput();
	};

	handleAddCurrentToFavorites = () => {
		const { isFavoritesFull, isFavorite, current, onAddFavorite, onDismissFavorite } = this.props;
		isFavorite && isFavorite(current)
			? onDismissFavorite && onDismissFavorite(current)
			: !isFavoritesFull && onAddFavorite && onAddFavorite(current);
	};

	render({
		pending,
		onSearchInput,
		onSetCurrent,
		onAddFavorite,
		onDismissFavorite,
		maxFavorites,
		maxRecent,
		isFavoritesFull,
		isFavorite,
		isPrimary,
		isCurrent,
		primary = {},
		current = {},
		favorites = [],
		recent = [],
		searchResults,
		label,
		searchTerm,
		...props
	}, { open }) {
		delete props.onChange;
		delete props.onChangeCurrent;
		delete props.onChangeFavorites;
		delete props.onChangeRecent;
		delete props.onChangeSearchTerm;

		return (
			<ClickOutsideDetector onClickOutside={open && this.handleCloseInput}>
				<div class={cx(style.container, open && style.open, props.class)}>
					{!open ? ([
						<div class={style.toggleContainer}>
							<button
								{...props}
								class={style.toggleButton}
								anchor="right"
								icon="cog-wire-cube"
								iconPosition="left"
								onClick={this.handleOpenInput}
							>
								{' '}
								{pending ? (
									<LoadingText />
								) : (
									<p>{label || current.name || <Text id="changeLocation" />}</p>
								)}
								<Icon name="cog-wire-cube" />
							</button>
						</div>,
						<button class={cx(style.iconButton, isFavorite && isFavorite(current) && style.favorite)} onClick={this.handleAddCurrentToFavorites}>
							<Icon name={isPrimary && isPrimary(current) ? 'current-location-wire-cube' : 'star-cube'} />
						</button>
					]) : ([
						<SearchForLocation value={searchTerm} onInput={onSearchInput} hideHeader refocus={open} />,
						<div class={style.dropdown}>
							{searchTerm && searchTerm.length ? (
								<SearchResults
									locations={searchResults}
									onSetCurrent={this.handleSetCurrent}
									onAddFavorite={!isFavoritesFull && this.handleAddFavorite}
									isFavorite={isFavorite}
									isFavoritesFull={isFavoritesFull}
								/>
							) : ([
								<PrimaryLocation location={primary} onSetCurrent={this.handleSetCurrent} />,
								<FavoriteLocations
									locations={favorites}
									maxFavorites={maxFavorites}
									onSetCurrent={this.handleSetCurrent}
									onDismissFavorite={onDismissFavorite}
								/>,
								Boolean(recent.length) && (
									<RecentLocations
										locations={recent}
										maxFavorites={maxFavorites}
										onSetCurrent={this.handleSetCurrent}
										onAddFavorite={!isFavoritesFull && this.handleAddFavorite}
										isFavoritesFull={isFavoritesFull}
									/>
								)
							])}
						</div>
					])}
				</div>
			</ClickOutsideDetector>
		);
	}
}
